var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.475 11.525L11.525 10.475L8.75 7.7V4.25H7.25V8.3L10.475 11.525ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9812 2.69375 13.3062C2.01875 12.6312 1.48437 11.8375 1.09062 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09062 5.075C1.48437 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48437 5.075 1.09062C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09062C11.8375 1.48437 12.6312 2.01875 13.3062 2.69375C13.9812 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9812 12.6312 13.3062 13.3062C12.6312 13.9812 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5ZM8 14C9.6625 14 11.0781 13.4156 12.2469 12.2469C13.4156 11.0781 14 9.6625 14 8C14 6.3375 13.4156 4.92187 12.2469 3.75312C11.0781 2.58437 9.6625 2 8 2C6.3375 2 4.92187 2.58437 3.75312 3.75312C2.58437 4.92187 2 6.3375 2 8C2 9.6625 2.58437 11.0781 3.75312 12.2469C4.92187 13.4156 6.3375 14 8 14Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.92cddcbfe0e95fa8795c6715d92598ee.svg";
export { ForwardRef as ReactComponent };